import { AxiosError } from 'axios'
import i18n from 'i18next'

import { alert } from './alert'
import { decodeAccessToken } from './decodeAccessToken'
import { getNavigator } from './getNavigator'
import { wait } from './wait'

import { authContextRef } from '~contexts'
import { Routes } from '~types/routesNames'

export let logoutMessageShown = false

export const signOutWhenNotAuthorized = async (error: AxiosError) => {
  const navigator = getNavigator()

  const authToken = (error?.config?.headers?.Authorization ?? 'NOT_FOUND') as string
  const decodedToken = decodeAccessToken(authToken)

  const isTokenInvalid =
    error?.config?.baseURL &&
    (!decodedToken || error.response?.status === 401 || error.response?.status === 403)

  if (isTokenInvalid && !logoutMessageShown && authContextRef.current?.isSignedIn) {
    logoutMessageShown = true
    alert(i18n.t('session.expired'), i18n.t('session.sign_in_again'), [
      {
        text: 'OK',
        onPress: async () => {
          await authContextRef.current?.signOut()
          await wait(1000)

          if (navigator) {
            navigator.navigate(Routes.SignIn)
          }
          logoutMessageShown = false
        },
      },
    ])
  }
}
